import { Api } from '../../services/api';

export const LoginRequest = async (nick, senha) => {
  try {
    const request = await Api.post('/user/login', {
      nick,
      senha,
    });

    return request.data;
  } catch (error) {
    return null;
  }
};
